
import HttpClient from "@/services/HttpClient/HttpClient";
import Vue from "vue";

export default Vue.extend({
  name: "Login",
  data: function () {
    return {
      fromRegistration: false,
      fromConfirmation: false,
      fromResetPasswordRequest: false,
      fromResetPasswordAction: false,
      username: "",
      password: "",
      formErrors: Array<string>(),
      currentUserInfos: null,
    };
  },
  props: {
    nextUrl: String,
  },
  mounted() {
    console.log("this.nextUrl");
    console.log(this.nextUrl === undefined);
    console.log("this.nextUrl login");
    console.log(this.nextUrl);
    this.fromRegistration = this.$route.query.registration === "true";
    this.fromConfirmation = this.$route.query.confirmation === "true";
    this.fromResetPasswordAction = this.$route.query.reset_password === "true";
    this.fromResetPasswordRequest =
      this.$route.query["reset-password-request"] === "true";
  },
  methods: {
    validateEmail: function (email: string) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    checkLoginForm: function () {
      this.formErrors = [];
      let isValid = true;
      if (!this.username || this.username.trim() === "") {
        isValid = false;
        this.formErrors.push("L'email est obligatoire.");
      } else if (!this.validateEmail(this.username)) {
        isValid = false;
        this.formErrors.push("L'email est invalide.");
      }

      if (!this.password || this.password.trim() === "") {
        this.formErrors.push("Le mot de passe est obligatoire.");
      }

      return isValid;
    },
    login: function () {
      if (this.checkLoginForm()) {
        const httpClient = new HttpClient();
        httpClient
          .loginUser({
            username: this.username,
            password: this.password,
          })
          .then((value) => {
            const token = value.data.token;
            httpClient
              .getCurrentUserInformations(token)
              .then((value1) => {
                console.log("value1");
                console.log(value1);
                this.currentUserInfos = value1.data;
                localStorage.setItem(
                  "currentUser",
                  JSON.stringify(value1.data)
                );
                localStorage.setItem("jwt-token", token);
                if (
                  this.nextUrl === undefined ||
                  this.nextUrl === null ||
                  this.nextUrl === "undefined"
                ) {
                  if (value1.data.roles.includes("ROLE_COMPANY")) {
                    window.location.href = "/company/account";
                  } else if (value1.data.roles.includes("ROLE_SEEKER")) {
                    window.location.href = "/candidate/account";
                  }
                } else {
                  window.location.href = this.nextUrl;
                }
              })
              .catch((reason) => {
                console.log(reason);
                this.formErrors = [];
                this.formErrors.push(
                  "Une erreur est survenue après la connexion. Veuillez réessayer ultérieurement"
                );
              });
          })
          .catch((reason) => {
            this.formErrors = [];
            this.formErrors.push("Identifiants invalides");
          });
      }
    },
  },
});
